<template>
	<v-card>
		<v-card-title>Gruppeninterne Nachrichten</v-card-title>
		<v-card-text>
			<v-list v-if="group.notes">
				<Note v-for="note in group.notes" :key="note.id" :note="note" :id="id" collection="groups"></Note>
			</v-list>
			<p v-else>No notes found</p>
			<v-text-field class="mt-4" filled v-model="message" label="Nachricht Schreiben" v-on:keyup.enter="addNote()"></v-text-field>
			<p class="text-right">
				<v-btn rounded color="primary2" @click="addNote" dark>
					Beitrag Hinzufügen
				</v-btn>
			</p>
		</v-card-text>
		<v-card-actions>
		</v-card-actions>
	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import Note from "@/components/elements/Note"
	export default {
		name: "GroupNotes", 
		props: {
			id: {type: String}
		},
		data: () => {
			return {
				message: ''
			}
		},
		components: {
			Note
		},
		computed: {
			...Vuex.mapState({
				user: state => state.user, 
				groups: state => state.groups
			}), 
			group(){
				var id = this.id
				return this.groups.find( g => g.id == id )
			}, 
		},
		methods: {
			addNote(){
				var id = this.id;
				var dt = new Date();
				var note = {
					author: this.user.id, 
					content: this.message,
					created: dt.toString(),
					id: this.generateId()
				}
				this.$store.dispatch( "groups/addNote", {note: note, group_id: id});
				this.message = ""
			}
		}
		// created(){
			
		// }

	}
</script>